import OtherPossessions from './OtherPossessions';

export default OtherPossessions;
export { OtherPossessions };
